import { ActionCreator, AjaxDispatcher } from "./ajax-dispatcher";
import { addClass, addEventListenerIfNotExists, disable, enable, getApiUrl, getCurrentLanguageId, removeClass } from "./common";
import HttpClient from "./http-client";
import LoadingIndication from "./loading-indication";

export default class DiscountCoupons {
    private baseComponent: HTMLElement;
    private couponErrorsPart: HTMLElement;
    private couponCodeInput: HTMLInputElement;
    private couponSubmitBtn: HTMLElement;
    private couponsErrorsList: HTMLElement;

    constructor() {
        this.initElements();
        this.registerEventListeners();
    }

    private initElements(): void {
        this.baseComponent = document.querySelector('[data-component="DiscountCoupons"]');
        this.couponErrorsPart = document.querySelector('[data-component-part="coupon-errors"]');
        this.couponCodeInput = document.querySelector('#coupon-control-input');
        this.couponSubmitBtn = document.querySelector('#coupon-control-button');
        this.couponsErrorsList = document.querySelector('#coupon-errors-list');
        this.disableHtmlElement(this.couponSubmitBtn);
    }

    private registerEventListeners(): void {
        addEventListenerIfNotExists(this.couponSubmitBtn, 'click', async (event: Event) => {
            await this.applyDiscountCoupon();
        });

        addEventListenerIfNotExists(this.couponCodeInput, 'keypress', async (event: KeyboardEvent) => {
            if (event.key == 'Enter' && this.couponCodeInputNotEmpty())
                await this.applyDiscountCoupon();
        });

        addEventListenerIfNotExists(this.couponCodeInput, 'input', (event: InputEvent) => {
            if (this.couponCodeInputNotEmpty()) {
                this.enableHtmlElement(this.couponSubmitBtn);
            } else {
                this.disableHtmlElement(this.couponSubmitBtn);
            }
        });
    }

    private couponCodeInputNotEmpty(): boolean {
        return this.couponCodeInput.value.trim() !== '';
    }

    private async applyDiscountCoupon(): Promise<void> {
        this.showLoadingIndication();
        var couponCode = this.couponCodeInput.value;
        await this.applyDiscountCouponToCart(couponCode);
        this.hideLoadingIndication();
    }

    private async applyDiscountCouponToCart(couponCode: string): Promise<void> {
        const client = new HttpClient();
        const url = `${getApiUrl()}/cart/apply-discount-coupon`;

        const response = await client.fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;',
                'Current-Language-Id': getCurrentLanguageId()
            },
            body: JSON.stringify({
                DiscountCode: couponCode.trim()
            })
        }, async (response: Response) => {
            this.clearErrorMessages();
            if (response.status == 500) {
                this.addErrorMessages([`There was an error when applying coupon. Please contact eshop owner. (Status: ${response.status} Status Text: ${response.statusText})`]);
            } else {
                var responseObject = await response.json() as CartDiscountCouponResponse;
                this.addErrorMessages(responseObject.messages);
            }
            this.showCouponsErrorsSection();
        });

        if (response.ok) {
            this.reloadComponents();
        }
    }

    private reloadComponents(): void {
        const action = new ActionCreator().reloadComponents(['Cart', 'CartHeaderIcon', 'DiscountCoupons', 'DiscountCouponsList']);
        new AjaxDispatcher().dispatchGetAction(action);
    }

    private enableHtmlElement(element: HTMLElement): void {
        element.style.pointerEvents = "auto";
        removeClass(element, 'disabled');
        enable(element);
    }

    private disableHtmlElement(element: HTMLElement): void {
        element.style.pointerEvents = "none";
        addClass(element, 'disabled');
        disable(element);
    }

    private showLoadingIndication(): void {
        LoadingIndication.show(this.baseComponent);
    }

    private hideLoadingIndication(): void {
        LoadingIndication.hide(this.baseComponent);
    }

    private showCouponsErrorsSection(): void {
        this.couponErrorsPart.style.display = 'flex';
    }

    private addErrorMessages(errorMessages: string[]): void {
        errorMessages.forEach(message => {
            const item = document.createElement('li');
            item.dataset.testid = 'cart-coupon-error';
            item.textContent = message;
            this.couponsErrorsList.appendChild(item);
        });
    }

    private clearErrorMessages(): void {
        this.couponsErrorsList.innerHTML = '';
    }
}

interface CartDiscountCouponResponse {
    couponId: number;
    couponCode: string;
    messages: string[];
}
